import request from '@/utils/request'
const purchaseUrl = process.env.VUE_APP_PURCHASE_API
const passportUrl = process.env.VUE_APP_COMPANY_API

// 分页查询文档资料
export function getJxicDocumentPageApi(params) {
  return request({
    url: purchaseUrl + '/workbench/purchaser/document/page',
    method: 'get',
    params
  })
}

// 添加文档资料
export function addJxicDocumentApi(data, identity) {
  return request({
    url: purchaseUrl + '/workbench/purchaser/document',
    method: 'post',
    data,
    headers: {
      identity
    }
  })
}

// 删除文档资料
export function removeJxicDocumentApi(documentId) {
  return request({
    url: purchaseUrl + `/workbench/purchaser/document/${documentId}`,
    method: 'delete'
  })
}

// 更新文档资料
export function updateJxicDocumentApi(documentId, data) {
  return request({
    url: `${purchaseUrl}/workbench/purchaser/document/${documentId}/document`,
    method: 'put',
    data
  })
}

// 预览文档（未发布）
export function previewUnReleaseJxicDocumentApi(params) {
  return request({
    url: purchaseUrl + `/workbench/purchaser/document/preview-document-file`,
    method: 'get',
    params
  })
}

// 下载文档（未发布）
export function downloadUnReleaseJxicDocumentApi(params) {
  return request({
    url: purchaseUrl + `/workbench/purchaser/document/download-document-file`,
    method: 'get',
    params
  })
}

// 预览文档（已上传）
export function previewJxicDocumentApi(params) {
  return request({
    url:
      purchaseUrl +
      `/workbench/purchaser/document/${params.documentId}/preview-document-file`,
    method: 'get',
    params
  })
}

// 下载文档（已上传）
export function downloadJxicDocumentApi(params) {
  return request({
    url:
      purchaseUrl +
      `/workbench/purchaser/document/${params.documentId}/download-document-file`,
    method: 'get',
    params
  })
}

// ------------ 省投自动化采购报告相关接口 -------------------
// 分页查询报告列表
export function getJxicPurchaseReportPageApi(params) {
  return request({
    url: passportUrl + '/enterprise/companies/purchase-reports/page',
    method: 'get',
    params
  })
}

// 查询采购报告信息
export function getJxicPurchaseReportApi(reportId) {
  return request({
    url: passportUrl + `/enterprise/companies/purchase-reports/${reportId}`,
    method: 'get'
  })
}

// 更新采购报告内容
export function changeJxicPurchaseReportApi(reportId, data) {
  return request({
    url:
      passportUrl +
      `/enterprise/companies/purchase-reports/${reportId}/content`,
    method: 'put',
    data
  })
}
